import type { BoardDestination } from '../routingBoard/types';
import type { CreateOutput } from './types';

/**
 * Extra dest cards for authoring. HISTORY STORE stays on the read board.
 * Skip Observe when it is the same store as the existing history-store card.
 */
export function extraBoardDestinations(
  outputs: CreateOutput[],
  destinations: BoardDestination[]
): CreateOutput[] {
  const history = destinations.find((dest) => dest.kind === 'history_store');
  const historyStore = String(history?.store || history?.label || '').trim();
  return outputs.filter((item) => {
    if (!item.available) return false;
    if (item.store === 'Observe' && historyStore && item.path === historyStore) {
      return false;
    }
    return true;
  });
}

export function historyStoreIsObserve(destinations: BoardDestination[]): boolean {
  const history = destinations.find((dest) => dest.kind === 'history_store');
  return String(history?.store || '').trim() === 'api_ingest_history';
}
